import React, { Component, PropTypes } from "react";
import { Input, Dropdown, Loader, Dimmer, Checkbox } from "semantic-ui-react";
import { connect } from "react-redux";
import {
  ValidMe,
  forceValidation,
  validatePhoneNumber,
  phoneTypesEnum,
  EMAIL_VALIDATION_REGULAR_EXPRESSION
} from "../../shared/validMeReact";
import {
  getApiCustomerProfileData,
  updateBookingOnlyCustomerProfileData,
  setIsLoadingOnCustomerProfile,
  updateCustomerProfileData,
  resetCustomerProfileForm
} from "../../../actions/customerProfile";
import objectAssign from "object-assign";
import AddressForm from "../../shared/addressForm";
import {
  updateGlobalErrorMessage,
  removeGlobalErrorMessageIfMatchesThisString
} from "../../../actions/globalError";
import { menuNamesEnum } from "../../../state/initialState";
import { updateCurrentMenu } from "../../../actions/menu";
import { formatPhone } from "../../../utils/helpers";

@connect(mapStateToProps)
export default class CenterPanelBookingOnlyCustomerProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredHelpAddress: false,
      hoveredHelpUpdateAllRecords: false,
      hoveredHelpViewCustomerDetails: false
    };
  }

  componentWillMount() {
    let {
      limitedPermissions,
      appointmentStepData: { selectedCustomer }
    } = this.props;
    if (selectedCustomer.id && limitedPermissions.canViewCustomerProfile) {
      this.props.dispatch(getApiCustomerProfileData(selectedCustomer.id));
    }
  }

  componentDidMount() {
    let { bookingOnlyCustomerProfileData } = this.props;
    sessionStorage.setItem(
      "BOOKING_ONLY_CUSTOMER_PROFILE_SNAPSHOT",
      JSON.stringify(bookingOnlyCustomerProfileData)
    );

    this.props.dispatch(updateGlobalErrorMessage(""));
  }

  dispatchUpdateCurrentMenu = menuSelected => {
    this.props.dispatch(updateCurrentMenu(menuSelected));
  };

  updateCustomerProfileData = data => {
    let newData = objectAssign({}, this.props.customerProfileData, data);
    this.props.dispatch(updateCustomerProfileData(newData));
  };

  dispatchResetCustomerProfileForm = () => {
    this.props.dispatch(resetCustomerProfileForm());
  };

  updateAllRecordsHandler = () => {
    this.dispatchResetCustomerProfileForm();
    setTimeout(() => {
      let {
        selectedCustomer,
        customerNameOrPhonenumberSearchQuery
      } = this.props.appointmentStepData;
      if (!selectedCustomer.id) {
        let customerData = {
          firstName: customerNameOrPhonenumberSearchQuery.split(" ")[0] || "",
          lastName: customerNameOrPhonenumberSearchQuery.split(" ")[1] || ""
        };
        let newData = objectAssign(
          {},
          this.props.customerProfileData,
          customerData
        );
        this.props.dispatch(updateCustomerProfileData(newData));
      }
      this.dispatchUpdateCurrentMenu(
        menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_EDIT
      );
      setTimeout(() => {
        this.props.dispatch(getApiCustomerProfileData(selectedCustomer.id));
      }, 0); //execute after going to next page
    }, 0);
  };

  updateBookingOnlyCustomerProfileData = data => {
    let newData = objectAssign(
      {},
      this.props.bookingOnlyCustomerProfileData,
      data
    );
    this.props.dispatch(updateBookingOnlyCustomerProfileData(newData));
  };

  updateCustomerAddressData = () => {};

  firstNameChangeHandler = event => {
    this.updateBookingOnlyCustomerProfileData({
      firstName: event.target.value
    });
    setTimeout(() => {
      forceValidation(null, null, "customerProfileNames");
    }, 0);
  };

  lastNameChangeHandler = event => {
    this.updateBookingOnlyCustomerProfileData({ lastName: event.target.value });
    setTimeout(() => {
      forceValidation(null, null, "customerProfileNames");
    }, 0);
  };

  emailChangeHandler = event => {
    let { apiCustomerProfileData } = this.props;
    let { ErrorEmailCannotBeDeletedInThisPage } = window.APP.LANGUAGE.Errors;

    // if (event.target.value == '' && apiCustomerProfileData.emails && apiCustomerProfileData.emails.length > 1) {
    //   this.props.dispatch(updateGlobalErrorMessage({message : ErrorEmailCannotBeDeletedInThisPage}));
    // } else {
    //   this.props.dispatch(removeGlobalErrorMessageIfMatchesThisString(ErrorEmailCannotBeDeletedInThisPage));
    // }
    this.updateBookingOnlyCustomerProfileData({ email: event.target.value });
  };

  phoneChangeHandler = event => {
    let { apiCustomerProfileData } = this.props;
    let { ErrorPhoneCannotBeDeletedInThisPage } = window.APP.LANGUAGE.Errors;

    let noSpacesPhone = event.target.value
      .split(" ")
      .join()
      .replace(/,/g, "")
      .replace(/\(/g, "")
      .replace(/\)/g, "")
      .replace(/-/g, "");
    var numericTest = /^\d+$/;
    if (
      numericTest.test(noSpacesPhone) ||
      event.target.value == "" ||
      event.target.value == "+"
    ) {
      if (event.type == "change") {
        if (
          event.target.value == "" &&
          apiCustomerProfileData.phonenumbers &&
          apiCustomerProfileData.phonenumbers.length > 1
        ) {
          this.props.dispatch(
            updateGlobalErrorMessage({
              message: ErrorPhoneCannotBeDeletedInThisPage
            })
          );
        } else {
          this.props.dispatch(
            removeGlobalErrorMessageIfMatchesThisString(
              ErrorPhoneCannotBeDeletedInThisPage
            )
          );
        }

        this.updateBookingOnlyCustomerProfileData({
          phoneNumber: event.target.value
        }); // DES- 709 formatting in change causes issues. Hence moved to blur. But without state update it will not reflect in UI.
      } else {
        this.updateBookingOnlyCustomerProfileData({
          phoneNumber: formatPhone(event.target.value)
        });
      }
    }

    if (event.type !== "change") {
      setTimeout(() => {
        forceValidation(null, null, "customerProfileContacts");
      }, 0); //execute in next loop
    }
  };

  updateBookingOnlyCustomerAddressData = data => {
    let newAddressData = objectAssign(
      {},
      this.props.bookingOnlyCustomerProfileData.address,
      data
    );
    this.updateBookingOnlyCustomerProfileData({ address: newAddressData });
  };

  address1ChangeHandler = addressValue => {
    this.updateBookingOnlyCustomerAddressData({ address1: addressValue });
  };

  cityChangeHandler = cityValue => {
    this.updateBookingOnlyCustomerAddressData({ city: cityValue });
  };

  stateChangeHandler = selectedState => {
    this.updateBookingOnlyCustomerAddressData({ state: selectedState });
  };

  postalCodeChangeHandler = zipCodeValue => {
    this.updateBookingOnlyCustomerAddressData({ postalcode: zipCodeValue });
  };

  blockedChangeHandler = event => {
    let { blocked } = this.props.customerProfileData;
    this.updateCustomerProfileData({ blocked: !blocked });
  };

  captureCCChangeHandler = () => {};

  openCustomerDetailspage = () => {
    let { organizationId, selectedCustomer } = this.props.appointmentStepData;
    if (selectedCustomer && selectedCustomer.id) {
      window.open(
        `${window.APP.apiDomain}/manager/customer/index/${organizationId}#cust_${selectedCustomer.id}`,
        "_blank"
      );
    }
  };

  handleHelpAddressMouseIn = () => {
    this.setState({ hoveredHelpAddress: true });
  };
  handleHelpAddressMouseOut = () => {
    this.setState({ hoveredHelpAddress: false });
  };

  handleHelpUpdateAllRecordsMouseIn = () => {
    this.setState({ hoveredHelpUpdateAllRecords: true });
  };
  handleHelpUpdateAllRecordsMouseOut = () => {
    this.setState({ hoveredHelpUpdateAllRecords: false });
  };
  handleHelpViewCustomerDetailsMouseIn = () => {
    this.setState({ hoveredHelpViewCustomerDetails: true });
  };
  handleHelpViewCustomerDetailsMouseOut = () => {
    this.setState({ hoveredHelpViewCustomerDetails: false });
  };

  canEditCurrentBooking = () => {
    let { limitedPermissions, currentBookingId } = this.props;
    return (
      limitedPermissions.canEditAllBookings ||
      (limitedPermissions.bookingsEditableByCurrentUser.indexOf(
        currentBookingId
      ) > -1 &&
        currentBookingId)
    );
  };

  render() {
    let { blocked, captureCreditCard } = this.props.customerProfileData;
    let {
      firstName,
      lastName,
      email,
      phoneNumber,
      address
    } = this.props.bookingOnlyCustomerProfileData;
    let {
      appointmentStepData: { selectedCustomer, multiServiceList },
      currentBookingId,
      limitedPermissions
    } = this.props;
    let { CustomerProfile } = window.APP.LANGUAGE.Pages;

    let phoneTypesSupported = `${phoneTypesEnum.MOBILE}-${phoneTypesEnum.FIXED_LINE}-${phoneTypesEnum.FIXED_LINE_OR_MOBILE}-${phoneTypesEnum.PERSONAL_NUMBER}-${phoneTypesEnum.VOIP}-${phoneTypesEnum.TOLL_FREE}`;
    let {
      UpdateAllCustomerRecords,
      DetailsTitle,
      RequiredFields,
      ContactTitle,
      OneFieldRequired,
      FirstNamePlaceholder,
      LastNamePlaceholder,
      EmailPlaceholder,
      PhonePlaceholder,
      AddressTitle,
      BlockCustomerText,
      AlwaysRequireCCText,
      ViewDetailsText,
      CannotEditCustomerProfileMessage,
      UpdateAllCustomersHelpMessage,
      ViewCustomerDetailsHelpMessage,
      UpdateBookingOnlyCustomerHelpMessage
    } = CustomerProfile;

    let cannotEditBooking =
      !limitedPermissions.canEditAllBookings &&
      limitedPermissions.bookingsEditableByCurrentUser.indexOf(
        currentBookingId
      ) < 0 &&
      currentBookingId;

    let canCreateCustomerByUsingBookingFormFields =
      !limitedPermissions.canCreateCustomerProfile &&
      !limitedPermissions.canSearchForCustomers &&
      (this.canEditCurrentBooking() || !currentBookingId);

    let addDisableClass = canCreateCustomerByUsingBookingFormFields
      ? ""
      : "disabled";

    let that = this;
    return (
      <div className="tabpane customer-profile-tab">
        <div className="ui two column grid">
          <section className="customer-info column">
            <ValidMe
              condition={() => {
                return (
                  this.props.bookingOnlyCustomerProfileData.firstName.length >
                    0 || this.props.customerProfileData.lastName.length > 0
                );
              }}
              validmemessagecondition={CustomerProfile.Errors.NameRequired}
              validmefor="condition"
              group="customerProfileNames"
            >
              <h5 className="label-title">
                {DetailsTitle} <span>{RequiredFields}</span>
              </h5>
              <Input
                disabled={
                  cannotEditBooking &&
                  !canCreateCustomerByUsingBookingFormFields
                }
                value={firstName}
                onChange={this.firstNameChangeHandler}
                autoComplete="off"
                name="booking_firstName"
                tabIndex="1"
                placeholder={FirstNamePlaceholder}
                className="booking_firstname booking_auto_complete"
              />
            </ValidMe>
            <ValidMe
              condition={() => {
                return (
                  this.props.bookingOnlyCustomerProfileData.firstName.length >
                    0 ||
                  this.props.bookingOnlyCustomerProfileData.lastName.length > 0
                );
              }}
              validmemessagecondition={CustomerProfile.Errors.NameRequired}
              validmefor="condition&numeric"
              group="customerProfileNames"
            >
              <Input
                disabled={
                  cannotEditBooking &&
                  !canCreateCustomerByUsingBookingFormFields
                }
                value={lastName}
                onChange={this.lastNameChangeHandler}
                autoComplete="off"
                name="booking_lastName"
                tabIndex="2"
                placeholder={LastNamePlaceholder}
                className="booking_lastname  booking_auto_complete"
              />
            </ValidMe>
          </section>
          <section className="customer-info2 column">
            <ValidMe
              hideerrorsofgroupifallgood={true}
              condition={value => {
                let emailValue = value;
                let conditionFulfilled =
                  emailValue.length > 0 ||
                  that.props.bookingOnlyCustomerProfileData.phoneNumber.length >
                    0; //DES-745
                if (
                  value != "" &&
                  !EMAIL_VALIDATION_REGULAR_EXPRESSION.test(value)
                ) {
                  conditionFulfilled = false;
                }

                return conditionFulfilled;
              }}
              validmemessagecondition={CustomerProfile.Errors.ContactRequired}
              validmemessage={window.APP.LANGUAGE.Errors.EmailInvalid}
              secondaryconditionpassed={
                this.props.customerProfileData.phoneNumber.length > 0
              }
              optional
              validmefor="condition&email"
              group="customerProfileContacts"
            >
              <h5 className="label-title">
                {ContactTitle} <span>{OneFieldRequired}</span>
              </h5>
              <Input
                disabled={
                  cannotEditBooking &&
                  !canCreateCustomerByUsingBookingFormFields
                }
                type="email"
                value={email}
                onBlur={() => {
                  setTimeout(() => {
                    forceValidation(null, null, "customerProfileContacts");
                  }, 0); //execute in next loop
                }}
                onChange={this.emailChangeHandler}
                autoComplete="off"
                name="booking_email"
                tabIndex="3"
                placeholder={EmailPlaceholder}
                className="booking_email_cp booking_auto_complete customer-email"
              />
            </ValidMe>
            <ValidMe
              hideerrorsofgroupifallgood={true}
              condition={(value, validRules, props) => {
                let phone = value;
                let conditionFulfilled =
                  that.props.bookingOnlyCustomerProfileData.email.length > 0 ||
                  phone.length > 0; //DES-745
                  phone = phone.replace("+", "");
                if (
                  value != "" &&
                  !validatePhoneNumber(phone, validRules, props).good
                ) {
                  conditionFulfilled = false;
                }

                return conditionFulfilled;
              }}
              validmemessagecondition={CustomerProfile.Errors.ContactRequired}
              validmemessage={window.APP.LANGUAGE.Errors.PhoneNumberIsInvalid}
              secondaryconditionpassed={
                this.props.customerProfileData.email.length > 0
              }
              optional
              validmefor={`condition&phoneNumber@${phoneTypesSupported}`}
              group="customerProfileContacts"
            >
              <Input
                disabled={cannotEditBooking}
                onBlur={this.phoneChangeHandler}
                type="tel"
                value={phoneNumber}
                onChange={this.phoneChangeHandler}
                autoComplete="off"
                name="booking_phonenumber"
                tabIndex="4"
                placeholder={PhonePlaceholder}
                className="phone-input booking_auto_complete customer-phone"
              />
            </ValidMe>
          </section>
        </div>

        <hr />
        <div className={`ui grid  ${addDisableClass}`}>
          <section className={`address eight wide column ${addDisableClass}`}>
            <label className="label-title">{AddressTitle}</label>
            {!limitedPermissions.canEditCustomerProfile ? (
              <span
                onMouseOver={this.handleHelpAddressMouseIn}
                onMouseOut={this.handleHelpAddressMouseOut}
                className="message-on-top-tooltip"
              >
                {this.state.hoveredHelpAddress ? (
                  <div className="contact-details-no-access-help">
                    {CannotEditCustomerProfileMessage}
                  </div>
                ) : (
                  ""
                )}
              </span>
            ) : (
              ""
            )}
            <AddressForm
              postalCodeChangeHandler={this.postalCodeChangeHandler}
              disabled={
                cannotEditBooking && !canCreateCustomerByUsingBookingFormFields
              }
              addressValue={address}
              addressChangeHandler={this.address1ChangeHandler}
              cityChangeHandler={this.cityChangeHandler}
              stateChangeHandler={this.stateChangeHandler}
              postalCodeChangeHandler={this.postalCodeChangeHandler}
            />
          </section>
          <section
            className={`customer_controls eight wide column ${addDisableClass}`}
          >
            <div className="block-customer-label">
              <span className="block_customer">{BlockCustomerText}</span>
              <Checkbox
                disabled={canCreateCustomerByUsingBookingFormFields}
                toggle
                checked={blocked}
              />
            </div>
            <div className="card-required-label">
              <span className="require-card">{AlwaysRequireCCText}</span>
              <Checkbox
                toggle
                disabled={canCreateCustomerByUsingBookingFormFields}
                checked={captureCreditCard}
              />
            </div>
            {selectedCustomer &&
            selectedCustomer.id &&
            limitedPermissions.canViewCustomerProfile ? (
              <div>
                <a
                  className="customer-details"
                  onClick={this.openCustomerDetailspage}
                >
                  {ViewDetailsText}
                </a>
                <span
                  onMouseOver={this.handleHelpViewCustomerDetailsMouseIn}
                  onMouseOut={this.handleHelpViewCustomerDetailsMouseOut}
                  className="view-customer-details-tooltip"
                >
                  {this.state.hoveredHelpViewCustomerDetails ? (
                    <div
                      className="tooltip-text"
                      dangerouslySetInnerHTML={{
                        __html: ViewCustomerDetailsHelpMessage
                      }}
                    ></div>
                  ) : (
                    ""
                  )}
                </span>
              </div>
            ) : (
              ""
            )}
          </section>

          <section className="eight wide column update-section">
            {selectedCustomer && selectedCustomer.id ? (
              <div className="update-all-records ">
                <label
                  dangerouslySetInnerHTML={{ __html: UpdateAllCustomerRecords }}
                ></label>
                <Checkbox
                  toggle
                  onChange={this.updateAllRecordsHandler}
                  checked={false}
                  disabled={!limitedPermissions.canCreateCustomerProfile}
                />
                <span
                  onMouseOver={this.handleHelpUpdateAllRecordsMouseIn}
                  onMouseOut={this.handleHelpUpdateAllRecordsMouseOut}
                  className="update-all-records-tooltip"
                >
                  {this.state.hoveredHelpUpdateAllRecords ? (
                    <div
                      className="update-all-records-tooltip-text"
                      dangerouslySetInnerHTML={{
                        __html: UpdateBookingOnlyCustomerHelpMessage
                      }}
                    ></div>
                  ) : (
                    ""
                  )}
                </span>
              </div>
            ) : (
              ""
            )}
          </section>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions,
    customerProfileData: state.customerProfileReducer.customerProfileData,
    bookingOnlyCustomerProfileData:
      state.customerProfileReducer.bookingOnlyCustomerProfileData,
    apiCustomerProfileData: state.customerProfileReducer.apiCustomerProfileData,
    businessCountryCode: state.appointmentStepReducer.businessCountryCode,
    currentBookingId: state.bookingReducer.currentBookingId,
    loadingCustomerProfile: state.customerProfileReducer.loadingCustomerProfile
  };
}
